import { render, staticRenderFns } from "./MasterPayerReport.vue?vue&type=template&id=1218a20e&"
import script from "./MasterPayerReport.vue?vue&type=script&lang=js&"
export * from "./MasterPayerReport.vue?vue&type=script&lang=js&"
import style0 from "./MasterPayerReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports